import axios from "axios";
import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ["form"];

  bulkEditServices(event) {
    event.preventDefault();
    showModal("#bulk-edit-services-modal");
    initializeBulkUpdateForm();
    let datatable = $(".selected-services-datatable").DataTable();
    datatable.clear().draw();
    datatable.rows.add(selectedServicesData).draw();
  }

  bulkUpdateServices(event) {
    event.preventDefault();
    const form = this.formTarget;

    if (!$(".service-cost-centre-checkbox").is(":checked") && !$(".service-description-checkbox").is(":checked")) {
      bootbox.alert({
        message: "At least one field must be selected to update",
        closeButton: false
      });
    } else {
      let updateValues = ''
      if ($(".service-cost-centre-checkbox").is(":checked")){
        updateValues += `<br><b>Cost Centre:</b> ${$("#service_accountCostCentreID").select2('data')[0].text}`
      }
      if ($(".service-description-checkbox").is(":checked")) {
        updateValues += `<br><b>Description:</b> ${$("#service_Description").val()}`
      }

      let confirmMsg = `Are you sure you want to update ${selectedServicesData.length} selected services with the following values?<br>${updateValues}`,
       successMsg = `${selectedServicesData.length} services has been updated successfully`,
       formData = $(form).serializeJSON();

      formData["service_ids"] = [];

      $(selectedServicesData).each(function (idx) {
        formData["service_ids"].push(selectedServicesData[idx]["serviceID"]);
      });

      hideModal("#bulk-edit-services-modal");

      bootbox.confirm({
        title: "Bulk Update Services",
        message: confirmMsg,
        callback: function (result) {
          if (result) {
            axios
             .patch(form.action, formData)
             .then(response => {
               showNotification("success", successMsg);
               selectedServicesData = [];
               ensureServiceCheckboxes();
               refreshBulkUpdateServicesWidgets();
               $(".services-datatable").DataTable().ajax.reload();
             })
             .catch(error => {
               showErrorMessage(error);
             });
          }
        }
      });
    }
  }

  export(event) {
    event.preventDefault();
    let searchData = filtersFormData($(".filters-form"));
    let url = `${this.data.get("url")}?`;
    Object.keys(searchData).forEach(
     key => (url += `&${key}=${searchData[key]}`)
    );

    bootbox.prompt({
      title: "Export Services",
      value: false,
      inputType: 'checkbox',
      inputOptions: [{
        text: "Include Expired Tariffs",
        value: true,
        name: "include_expired_tariffs"
      }],
      callback: function(result){
        if(result) {
          url += `&include_expired=${result[0]}`
          exportFile(url)
        }
      }
    })
  }
}
